import React  from 'react';
import Paypal from './../../../images/paypalLogo.png';
import Amazon from './../../../images/amazonLogo.png';

export const Logo = props => {
 const {
 merchantName
 } = props;
 if(merchantName === 'paypal'){
   return(<img src={Paypal} width="140" height="40" alt="Paypal logo"/>)
 } else if(merchantName === 'amazon'){
  return(<img src={Amazon} width="140" height="40" alt="Amazon logo"/>)
}else{
     return null;
   }
};
